const List = () => import("~/components/Views/Prova/RealizarProvaAlunos/List");
const Form = () => import("~/components/Views/Prova/RealizarProvaAlunos/Form");

import perfilVerify from "~/middleware/perfilVerify";
import auth from "~/middleware/auth";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Alunos", link: "" }
];

export const realizarProvas = [
  {
    path: "alunos/realizar-provas",
    component: List,
    name: "Realizar Provas",
    meta: {
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "alunos/realizar-prova/:aplicacaoProvaId",
    component: Form,
    name: "Realizar Prova",
    meta: {
      middleware: [auth, perfilVerify],
      breadcrumb,
      timer: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/alunos/realizarProvas.js